import { HomeSectionFive, ProgrammeCover, ProgrammeI, ProgrammeII, ProgrammeIII, ProgrammeIV } from '../components'

const Programme = () => {
  return (
    <div>
      <ProgrammeCover/>
      <ProgrammeI/>
      <ProgrammeII/>
      <ProgrammeIII/>
      <ProgrammeIV/>
      <HomeSectionFive/>
    </div>
  )
}

export default Programme
